export default __webpack_public_path__ + "static/brand-2-2ea096ca14e39c1358d0f57e83ebd886.png";